import { API_ENDPOINTS } from '../../../../constants/apiEndpoints';
import { ENVIRONMENT_CONFIG } from '../../../../constants/environmentConfig';
import fetcher from '../../../../helpers/fetcher';

export const getNewsLetters = async (
  page: number,
  limit: number,
  published: string | undefined
) => {
  try {
    const res = await fetcher.post(
      API_ENDPOINTS.NEWSLETTER.GET_PUBLIC_NEWSLETTER,
      {
        page,
        limit,
        published: published,
      },
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return res;
  } catch (error: any) {
    throw error;
  }
};
